import { render, staticRenderFns } from "./GasArchive.vue?vue&type=template&id=65877112&scoped=true&"
import script from "./GasArchive.vue?vue&type=script&lang=js&"
export * from "./GasArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65877112",
  null
  
)

export default component.exports